export enum ERemittaBiller {
  naicom = 'NAICOM',
  cifm = 'CIFM',
  arian = 'ARIAN',
}
